import { AxiosResponse } from "axios";
import { axiosOld } from "helpers/axios/axios";
import { Signal } from "interfaces/Signal";

const getSignals = async (liveId: string): Promise<AxiosResponse<Signal[]>> =>
    await axiosOld.get(`/sinais?Live=${liveId}`);

export default getSignals;
